export const REVIEW_STATUS = Object.freeze({
  ACCEPTED: 'ACCEPTED',
  REJECTED: 'REJECTED',
  PENDING: 'PENDING'
});
export const ANNOTATION_FILTER_TYPE = Object.freeze({
  ALL: 'ALL',
  ...REVIEW_STATUS
});
export const ANNOTATION_VISIBILITY_TOGGLE = Object.freeze({
  SHOW_ALL: 'SHOW_ALL',
  HIDE: 'HIDE'
});
export const FILTER_ACTION = Object.freeze({
  REMOVE: 'remove',
  ADD: 'add'
});